import {
	FETCH_AVAILABILITY_BEGIN,
	FETCH_AVAILABILITY_SUCCESS,
	FETCH_AVAILABILITY_FAILURE,
	SET_CURRENT_QUERY,
	SET_PROPERTY_POLICIES
} from '../actions/fetchAvailability'

import {
	REQUEST_PROMO_UPDATE
} from '../actions/requestPromoActions'

import merge from "lodash/merge"

const initialState = {
	loading: false,
	error: null
}

export default function fetchAvailabilityReducers(state = initialState, action) {
	switch(action.type) {
		case SET_CURRENT_QUERY:
			return {
				...state,
				loading: false,
				currentQuery: action.payload,
			}
		case SET_PROPERTY_POLICIES:
			return {
				...state,
				loading: false,
				propertyPolicies: action.payload,
			}
		case FETCH_AVAILABILITY_BEGIN:
			return {
				...state,
				loading: true,
				urlData: merge({}, state.urlData, action.payload),
				error: null
			}

		case FETCH_AVAILABILITY_SUCCESS:
		case REQUEST_PROMO_UPDATE:
			return {
				...state,
				loading: false,
				availability: merge({}, state.availability, action.payload)
			}

		case FETCH_AVAILABILITY_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				availability: [],
				urlData: {}
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fetchAvailabilityReducers.js